module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app bg-gray",
    attrs: {
      "id": "gwi-voucherDetail"
    }
  }, [_c('div', {
    staticClass: "scroll to-bottom-btn"
  }, [(_vm.voucherDetail.cardType === '01') ? _c('section', {
    staticClass: "bigger"
  }, [_c('div', {
    staticClass: "row myrow"
  }, [_vm._v("就诊凭证二维码")]), _vm._v(" "), _c('qrcode', {
    staticClass: "qrcode",
    attrs: {
      "id": "voucherDetail-qrcode",
      "size": 171,
      "cls": _vm.qrCls,
      "value": _vm.qrText
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('section', [_c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("就诊类型")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm._f("cardType")(_vm.voucherDetail.cardType)))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("姓名")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.voucherDetail.holderName))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("卡号")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm._f("dotted")(_vm.voucherDetail.cardNo)))])]), _vm._v(" "), _c('dl', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localChanel !== 'TFY'),
      expression: "localChanel !== 'TFY'"
    }],
    staticClass: "field"
  }, [_c('dt', [_vm._v("手机号")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm._f("dotted")(_vm.voucherDetail.mobileNo)))])])])]), _vm._v(" "), _c('footer', [_c('button', {
    staticClass: "btn-logout",
    attrs: {
      "id": "voucherDetail-btn-delete",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showConfirm = true
      }
    }
  }, [_vm._v("\n      解  绑\n    ")])]), _vm._v(" "), _c('confirm', {
    attrs: {
      "text": "确认解绑该凭证？"
    },
    on: {
      "on-sure": _vm.deleteVoucher
    },
    model: {
      value: (_vm.showConfirm),
      callback: function($$v) {
        _vm.showConfirm = $$v
      },
      expression: "showConfirm"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-317246b8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/voucher/VoucherDetail.vue
// module id = 807
// module chunks = 0